<template>
  <div class="inner-box">
    <el-form size="small">
      <div class="content-name">
        <h2 class="dp-ib">센터관할지역관리</h2>
        <el-form-item label-width="0px" style="float: right;">
          <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
          <!-- <el-button type="success" icon="el-icon-document-checked" @click="allChk">전체 선택</el-button> -->
        </el-form-item>
      </div>
    </el-form>

    <!-- 검색조건 영역 -->
    <div class="search-form">
      <el-form size="mini" label-width="80px">
        <el-row style="margin-bottom: 0px;">
          <el-col :span="6" style="margin-left: -20px;">
            <el-form-item label="주소">
              <el-select v-model="form.siNm">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                      v-for="(item, i) in combos['area1']"
                      :value="item"
                      :label="item"
                      :key="i">
                </el-option>
              </el-select>

              <el-select v-model="form.guNm" v-if="form.siNm != ''">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="(item, i) in combos['area2']"
                    :value="item"
                    :label="item"
                    :key="i">
                </el-option>
              </el-select>

              <el-select v-model="form.dongNm" v-if="form.guNm != ''">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="(item, i) in combos['area3']"
                    :value="item"
                    :label="item"
                    :key="i">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="상태" style="margin-left: -2em;">
              <el-select v-model="form.agentZoneStatus">
                <el-option value='' label="전체">==전체==</el-option>
                <el-option
                      v-for="item in combos['agentZoneStatus']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="AS지정점" label-width="85px">
              <el-select v-model="form.areaAgent">
                <el-option value='' label="전체">==전체==</el-option>
                <el-option
                      v-for="item in combos['areaAgent']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                </el-option>
              </el-select>
              <el-select v-model="form.areaAgentDetail" v-if="form.areaAgent != ''">
                <el-option value='' label="선택">선택</el-option>
                <el-option
                    v-for="item in combos['areaAgentDetail']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="AS기사">
              <el-select v-model="form.agerntUser">
                <el-option value='' label="선택">선택</el-option>
                <el-option
                      v-for="item in combos['agerntUser']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="제품군">
              <el-select v-model="form.modelId">
                <el-option value='' label="선택">선택</el-option>
                <el-option
                    v-for="item in combos['modelGroup']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 테이블 -->
    <div class="talbe-contain">
      <div class="table-sub-contain"  style="width: 100%;">
        <div class="table-area">
          <div class="table-b">
            <div class="table-header">
              <div class="table-name">
              </div>
              <div class="btn-wrap btn-type2 clearfix">
                <!--                <button class="btn-size btn-w-gray" @click="addRowd">-->
                <!--                  <span class="btn-icon">-->
                <!--                    <i class="fas fa-plus"></i>-->
                <!--                  </span>{{this.$i18n.messages[this.$store.state.locale].addRow}}-->
                <!--                </button>-->
              </div>
            </div>
            <!-- <dhx-grid ref="grid2" v-model="subData" :config="config_child" /> -->
            <ag-grid-vue
                ref="gridSub"
                style="width: 100%; height: 65vh; min-height: 25px;"
                class="ag-theme-alpine grid_search_height"
                :enableRangeSelection="true"
                :context="context"
                :suppressMaxRenderedRowRestriction="true"
                :suppressColumnVirtualisation="true"
                :suppressRowVirtualisation="true"
                :columnDefs="columnDefsSub"
                :defaultColDef="defaultColDefSub"
                :frameworkComponents="frameworkComponents"
                :rowData="subData"
                :gridOptions="gridOptionsSub"
                :suppressRowClickSelection="false"
                :statusBar="statusBar"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClicked"
            />
          </div>
        </div>

      </div> <!-- table sub contain -->
    </div> <!-- table contain -->

    <div class="table-header">
      <el-form style="display: grid; float: right;" size="small">
        <el-form-item label-width="0px">
          <el-button type="success" icon="el-icon-document-checked" @click="openModal">제품군 선택</el-button>
          <el-button type="info" icon="el-icon-close" @click="deleteGroup">제품군 삭제</el-button>
          <el-button type="primary" icon="el-icon-document-add" @click="save">지정</el-button>
          <el-button type="info" icon="el-icon-close" @click="deleteRow">지정취소</el-button>
        </el-form-item>
      </el-form>
    </div>

    <agent-zone-info ref="AgentZoneInfo"  :custParam="custParam" :key="componentKey"/>


  </div>


</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';
import AgentZoneInfo from '@/components/InfoManage/AgentZoneInfo/AgentZoneInfo.vue';
import ModelGroupModal from "@/components/InfoManage/AgentZoneInfo/ModelGroupModal";


/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

let times = 1;

export default {
  mixins: [common],
  name: "group",
  components: {AgentZoneInfo,ModelGroupModal},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      modelData:[],
      form: {
        asAgentId: "",
        asAgentNm: "",
        companyId: "",
        dongNm: "",
        guNm: "",
        siNm: "",
        userId: "",
        userNm: "",
        areaAgent: "",
        areaAgentDetail: "",
        agentZoneStatus: "",
        agerntUser: "",
        modelId: "",
      },
      defForm: {
        asAgentId: "",
        asAgentNm: "",
        companyId: "",
        dongNm: "",
        guNm: "",
        siNm: "",
        userId: "",
        userNm: "",
        areaAgent: "",
        areaAgentDetail: "",
        agentZoneStatus: "",
        agerntUser: "",
      },
      combos: {
        'asAgentType' : [],           //센터구분
        'areaAgent' : [],             //지역구분
        'areaAgentDetail' : [],             //지역구분
        'contractStatus' : [],        //계약상태
        'agentZoneStatus' : [],        //처리지역상태
        'agerntUser' : [],        //AS기사
        'area1' : [],        //시
        'area2' : [],        //구
        'area3' : [],        //동
        'modelGroup' : [], // 전체 제품군
      },
      componentKey: 0,
      data: [],
      subData: [],
      context: {
        headerAllCheckEvent: this.allChk
      },
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        valueFormatter: (params) => {
          // console.log('formatter called ' + times + ' times');
          times++;
          return params.value;
        },
        cellDataType: false,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      custParam: [],
      chkYn:false,
      delChkList: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;

      this.init();
      this.areaInit();
      this.goOpen();


      // this.$store.commit('loading')
      // this.$http
      //     .post("/api/agentZoneMng/list", {
      //       companyId: this.$store.state.loginInfo.compCd,
      //       zipStart: '',
      //       zipEnd: '',
      //       siNm: '',
      //       guNm: '',
      //       dongNm: '',
      //       statusYn: '',
      //       asAgentId: this.$route.query.asAgentId == undefined ? 0 : this.$route.query.asAgentId,
      //       userId: 0,
      //       sortType: '',
      //       page: 1,
      //       totalPage: 99999,
      //       totalCount: 0,
      //       curPage: 0,
      //       processTime: '',
      //     })
      //     .then(response => {
      //       this.subData = response.data
      //     }).finally(() => {
      //   this.$store.commit('finish')
      // });
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    modelFormat(modelId){
      let val = "";
      this.modelData.forEach(x=>{
        if(x.key == modelId) val = x.value;
      });
      return val;
    },
    forceRerender() {
      console.log()
      this.componentKey += 1;
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;

      this.gridApiSub.sizeColumnsToFit();
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autoGroupColumnDef = {
        field: 'menu_nm',
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSideGroupOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSideGroup = (dataItem) => {
        // indigroupe if node is a group
        //console.log(dataItem);
        return dataItem.group;
      };
      this.getServerSideGroupKey = (dataItem) => {
        // specify which group key to use
        return dataItem.menu_id;
      };

      this.columnDefsSub = [
        {
          headerName:'No',
          field:'no',
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          },
          hide : true
        },
        {
          headerName: '선택'
          , field:'regYn'
          , width : 15
          , editable: false
          ,headerComponent: 'checkboxRenderer',
          headerComponentParams: (params) => {
              return params;
          }
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {
          headerName: '주소', children: [
            {headerName: '', field: 'siNm', width: 50, editable: false},
            {headerName: '', field: 'guNm', width: 50, editable: false},
            {headerName: '', field: 'dongNm', width: 50, editable: false},
          ], width: 1200, editable: false
        },
        {headerName:'제품군', field:'modelId', width:400, editable:false,
          valueFormatter: function(params) {
            return vm.modelFormat(params.value);
          }
        },
        {headerName:'지정점', field:'asAgentNm', width:400, editable:false},
        {headerName:'AS기사', field:'userNm', width:400, editable:false},
      ]
    },
    //Main 그리드 SelctionChange 발생
    onSelectionChangedMain(event) {
      const voRow = this.gridApi.getSelectedRows() //선택된 Row
      this.groupDetail = this.defForm;
      this.$store.commit('loading')
      this.$http
          .post("/api/group/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            parentId: voRow[0].menu_id,
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 9999,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.selectId = voRow[0].menu_id;
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    onCellClicked(event) {
      const idx = event.rowIndex
      const field = event.colDef.field
      const form = this.form;


    },
    deleteGroup(){
      const grid = this.$refs.gridSub
      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "Y"
      })
      if(chkDatas.length == 0){
        this.$swal({ type: 'error', text: '제품군을 지정 취소 할 주소를 체크하세요.' });
        return false;
      }

      let submitList = [];
      for(var i=0; chkDatas.length > i; i++){
        submitList.push({
          siNm:chkDatas[i].siNm,
          guNm:chkDatas[i].guNm,
          dongNm:chkDatas[i].dongNm,
          modelId:chkDatas[i].modelId
        });
      }

      this.$http.put('/api/agentZoneMng/modelGroup/delete',submitList)
          .then(response => {
            this.$swal({ type: 'success', text: '지정 취소되었습니다.' });
            this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
        });

    },
    openModal(){
      const grid = this.$refs.gridSub
      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "Y"
      })
      if(chkDatas.length == 0){
        this.$swal({ type: 'error', text: '제품군을 지정 할 주소를 체크하세요.' });
        return false;
      }


      const vm = this;

      this.$modal.open({
        width: 200,
        component: ModelGroupModal,
        parent: this,
        props: {
          title: "제품군 선택"
        },
        events: {
          close(params) {
            console.log(params);
            let modelGroup = [];
            params.forEach(x=>{
              modelGroup.push({
                modelId: x.key
              })
            });

            vm.saveModel(modelGroup);
          },
        }
      });
    },
    goOpen() {

      this.$store.commit('loading')
      this.$http
          .post("/api/agentZoneMng/list", {
            companyId: this.$store.state.loginInfo.compCd,
            zipStart: '',
            zipEnd: '',
            siNm: this.form.siNm,
            guNm: this.form.guNm,
            dongNm: this.form.dongNm,
            statusYn: this.form.agentZoneStatus,
            asAgentId: this.form.areaAgentDetail != ''? this.form.areaAgentDetail : 0,
            userId: this.form.agerntUser != ''? this.form.agerntUser : 0,
            modelId : this.form.modelId != ''? parseInt(this.form.modelId) : 0,
            sortType: '',
            page: 1,
            totalPage: 99999,
            totalCount: 0,
            curPage: 0,
            processTime: '',
          })
          .then(response => {
            this.subData = response.data
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    allChk(){

      const grid = this.$refs.gridSub
      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "Y"
      })

      if(chkDatas.length === this.subData.length){
        this.gridOptionsSub.api.forEachNodeAfterFilter((v, i) => {
          v.data.regYn = "N"
          // this.subData.regYn = "0"
        })
      }else{
        this.gridOptionsSub.api.forEachNodeAfterFilter((v, i) => {
          v.data.regYn = "Y"
          // this.subData.regYn = "1"
        })
      }


      // this.$forceUpdate()
      // this.forceRerender();
      grid.rowData.forEach((x,i)=>{
        this.mainGridRefresh(i);
      })

    },
    mainGridRefresh(idx) {
      var rows = [];
      var rowNode = this.gridApi.getDisplayedRowAtIndex(idx);
      rows.push(rowNode);
      this.gridApi.redrawRows({ rowNodes: rows });
    },
    save() {


      const grid = this.$refs.gridSub
      const agentZoneInfo = JSON.parse(JSON.stringify(this.$refs.AgentZoneInfo.form));

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "Y"
      })

      if(chkDatas.length == 0){
        this.$swal({ type: 'error', text: '지정 할 주소를 체크하세요.' });
        return false;
      }

      let submitList = [];
      for(var i=0; chkDatas.length > i; i++){
        submitList.push({
          companyId: this.$store.state.loginInfo.compCd,
          siNm:chkDatas[i].siNm,
          guNm:chkDatas[i].guNm,
          dongNm:chkDatas[i].dongNm,
          userId: agentZoneInfo.agerntUser,
          updatorId: this.$store.state.loginInfo.id,
          processTime: ""
        });
      }

      this.$store.commit('loading')
      this.$http.put('/api/agentZoneMng/distrib',submitList)
          .then(response => {
            this.$swal({ type: 'success', text: '지정되었습니다.' });
            this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          }).finally(() => {
            this.$store.commit('finish')
          });

    },
    saveModel(ModelGroup) {

      const grid = this.$refs.gridSub

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "Y"
      })

      if(chkDatas.length == 0) {
        this.$swal({ type: 'error', text: '지정 할 주소를 체크하세요.' });
        return false;
      }

      let submitList = [];
      for(var i=0; chkDatas.length > i; i++){
        submitList.push({
          companyId: this.$store.state.loginInfo.compCd,
          siNm:chkDatas[i].siNm,
          guNm:chkDatas[i].guNm,
          dongNm:chkDatas[i].dongNm,
          modelGroup: ModelGroup,
          processTime: ""
        });
      }

      this.$http.put('/api/agentZoneMng/modelGroup/save',submitList)
          .then(response => {
            this.$swal({ type: 'success', text: '지정되었습니다.' });
            this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });

    },

    deleteRow() {

      const grid = this.$refs.gridSub
      const agentZoneInfo = JSON.parse(JSON.stringify(this.$refs.AgentZoneInfo.form));

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "Y"
      })

      if(chkDatas.length == 0){
        this.$swal({ type: 'error', text: '지정 취소 할 주소를 체크하세요.' });
        return false;
      }

      let submitList = [];
      for(var i=0; chkDatas.length > i; i++){
        submitList.push({
          companyId: this.$store.state.loginInfo.compCd,
          siNm:chkDatas[i].siNm,
          guNm:chkDatas[i].guNm,
          dongNm:chkDatas[i].dongNm,
          updatorId: this.$store.state.loginInfo.id,
          processTime: ""
        });
      }

      this.$store.commit('loading')
      this.$http.put('/api/agentZoneMng/clear',submitList)
          .then(response => {
            this.$swal({ type: 'success', text: '지정 취소되었습니다.' });
            this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          }).finally(() => {
            this.$store.commit('finish')
          });


    },
    cancel(){
      // groupInfo 초기화
    },
    async areaInit() {

      this.$store.commit('loading');
      await this.$http.post(`/api/agentZoneMng/area/init`,{
          companyId: this.$store.state.loginInfo.compCd,
          siNm: this.form.siNm,
          guNm: this.form.guNm,
          sortType: "",
          processTime: ""
      })
      .then(response => {
        this.combos['area1'] = [];
        this.combos['area2'] = [];
        this.combos['area3'] = [];
        response.data.areaSi.forEach(x=>{ this.combos['area1'].push(x.siNm);})
        if(this.form.siNm != '')response.data.areaGu.forEach(x=>{ this.combos['area2'].push(x.guNm);})
        if(this.form.guNm != '')response.data.areaDong.forEach(x=>{ this.combos['area3'].push(x.dongNm);})
      }).finally(() => {
        //this.goOpen();
        this.$store.commit('finish');
      });
    },
    async init() {

      let [zoneForm, areaModel] = await Promise.all([
        this.$http.post(`/api/agentZoneMng/init`,{ parentId: this.form.areaAgent, parentId2: this.form.areaAgentDetail }),
        this.$http.post(`/api/agentZoneMng/area/modelGroup` , { params: { catNm: this.modelNm || '' } })
      ]);

      this.combos['asAgentType'] = zoneForm.data.asAgentType;        //센터구분
      this.combos['areaAgent'] = zoneForm.data.areaAgent;            //지역구분
      this.combos['areaAgentDetail'] = zoneForm.data.areaAgentDetail;//지역구분상세
      this.combos['contractStatus'] = zoneForm.data.contractStatus;  //계약상태
      this.combos['agentZoneStatus'] = zoneForm.data.agentZoneStatus;  //처리지역상태
      this.combos['agerntUser'] = zoneForm.data.agerntUser;  //AS기사

      if(areaModel) {
        this.modelData = areaModel.data;
        this.combos['modelGroup'] = areaModel.data; // 전체 제품군
      }

      // this.$store.commit('loading');
      // await this.$http.post(`/api/agentZoneMng/init`,{
      //     parentId: this.form.areaAgent,
      //     parentId2: this.form.areaAgentDetail
      //     })
      //     .then(response => {
      //       this.combos['asAgentType'] = response.data.asAgentType;        //센터구분
      //       this.combos['areaAgent'] = response.data.areaAgent;            //지역구분
      //       this.combos['areaAgentDetail'] = response.data.areaAgentDetail;//지역구분상세
      //       this.combos['contractStatus'] = response.data.contractStatus;  //계약상태
      //       this.combos['agentZoneStatus'] = response.data.agentZoneStatus;  //처리지역상태
      //       this.combos['agerntUser'] = response.data.agerntUser;  //AS기사

      //     }).finally(() => {
      //       this.$store.commit('finish');
      //     });

          // this.$store.commit('loading')
          // this.$http.post("/api/agentZoneMng/area/modelGroup" , {params: {catNm: this.modelNm || ''}}
          // ).then(response => {
          //   if(response.data){
          //     this.modelData = response.data;
          //     this.combos['modelGroup'] = response.data; // 전체 제품군
          //   }
          // }).finally(() => {
          //   this.$store.commit('finish')
          // });
    },
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출
    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {

    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  watch: {
    'form.areaAgent'() {
      this.init();
    },
    'form.areaAgentDetail'() {
      this.init();
    },
    'form.siNm'() {
      this.areaInit();
      this.form.guNm = "";
    },
    'form.guNm'() {
      this.areaInit();
      this.form.dongNm = "";
    },
  }
};

</script>